import React from "react";
import PropTypes from "prop-types";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BILLING_INTERVALS } from "./owner-plans";

export function BillingIntervalSelector({ value, onValueChange }) {
  return (
    <Tabs value={value} onValueChange={onValueChange}>
      <TabsList aria-label="Periodo de facturación">
        <TabsTrigger value={BILLING_INTERVALS.MONTHLY}>Mensual</TabsTrigger>
        <TabsTrigger value={BILLING_INTERVALS.ANNUAL}>Anual</TabsTrigger>
      </TabsList>
    </Tabs>
  );
}

BillingIntervalSelector.propTypes = {
  value: PropTypes.string.isRequired,
  onValueChange: PropTypes.func.isRequired,
};

export default BillingIntervalSelector;
